<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">{{ $t("add") }} {{ $tc("role", 2) }}</div>
      <router-link class="btn-blue" to="roles"
        >{{ $tc("role", 2) }} {{ $tc("list") }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div
          v-for="(item, index) in Roles"
          :key="index"
          class="col-lg-6 col-xl-4 align-self-center mb-4"
        >
          <div v-if="item.fieldname !== 'role_id'">
            <div v-if="item.type !== 'radio'">
              <div class="d-flex align-items-center">
                <div class="input-material">
                  <input
                    placeholder="."
                    :type="item.type"
                    :name="item.fieldname"
                    :id="item.fieldname"
                    v-validate="item.validation"
                    v-model="item.fieldvalue"
                  />
                  <label>{{ $tc(item.label, 1) }}</label>
                </div>
                <Tooltip :title="$t(item.tooltip)" />
              </div>
              <p class="error_message">
                <span v-if="submitted && errors.has(item.fieldname)">{{
                  errors.first(`${item.fieldname}`)
                }}</span>
              </p>
            </div>
            <div v-if="item.type === 'radio'">
              <div class="d-flex align-items-center min-height-50">
                <label class="mb-0 mr-3">{{ $t(`${item.label}`) }}</label>
                <label class="ios-switch">
                  <input
                    type="checkbox"
                    class="ios-checkbox"
                    v-model="item.fieldvalue"
                  />
                  <span class="switch-slider"></span>
                </label>
              </div>
              <p class="error_message"></p>
            </div>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            class="btn-blue"
            @click.prevent.stop="handleSubmit(true)"
          >
            {{ $t("save") }}
          </button>
          <button
            :disabled="btenable"
            @click.prevent.stop="handleSubmit(false)"
            type="submit"
            class="btn-blue"
          >
            {{ $t("saveaddmore") }}
          </button>
          <button @click.prevent.stop="resetHandler" class="btn-black">
            {{ $t("reset") }}
          </button>
          <b-button class="btn-outline-grey" variant="default" to="roles">{{
            $t("cancel")
          }}</b-button>
        </div>
      </form>
    </div>

    <div class="white-wrapper" v-if="false">
        <div>
          <div class="col-md-5 pl-0 mb-4">
            <b-form-input
              v-debounce:300="searchFilterRoles"
              v-model="searchValue"
              placeholder="Search for Role...."
            ></b-form-input>
          </div>
          <div v-if="modules.length==0" class="text-center my-5 py-5 section-border">
            <h3 class="mb-0">No Roles Found</h3>
          </div>
          <div
            v-for="mod in modules"
            :key="mod.module_category_id"
            class="mt-3"
          >
            <div
              class="section-title section-border role-title d-flex justify-content-between align-items-center"
              v-b-toggle="`collapse-${mod.module_category_id}`"
            >
              <div class="mb-0">{{ mod.module_name }}</div>
              <button type="button" class="btn-transparent chevron">
                <img
                  src="@/assets/img/icons/primary/chevron-down.svg"
                  height="24"
                  width="24"
                />
              </button>
            </div>
            <b-collapse :id="`collapse-${mod.module_category_id}`">
              <table class="list-view-table mt-2 mb-1">
                <thead>
                  <tr>
                    <th>Module</th>
                    <th>
                      <b-form-checkbox
                        class="j-checkbox ml-1"
                        v-model="mod.view"
                        :value="true"
                        :unchecked-value="false"
                        @change="selectAllPermissions(mod)"
                        >View</b-form-checkbox
                      >
                    </th>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(mod1, moduleIndex1) in mod.modules"
                    :key="moduleIndex1"
                  >
                    <td>{{ mod1.module_name }}</td>
                    <td>
                      <b-form-checkbox
                        class="j-checkbox"
                        v-model="selectedModules"
                        :value="mod1.module_id"
                        >&nbsp;</b-form-checkbox
                      >
                    </td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </b-collapse>
          </div>
        </div>
    </div>
  </div>
</template>


<script>
import MasterService from "@/services/MasterService";
import Roles from "@/helper/formJSONMaster/Roles";
import timePicker from "@/components/Partials/materialTimePicker.vue";
import UserService from "@/services/UserService";

export default {
  components: {
    timePicker,
  },
  data() {
    return {
      btenable: false,
      Roles: Roles.ms_roles,
      submitted: false,
      Methods: Roles.Methods,
      accessLevels: ["View application Information", true, false],
      modules: [],
      modulesCopy: [],
      selectedModules: [],
      ro_id: "",
      cRoleName: "",
      searchValue: "",
    };
  },
  mounted() {
    this.resetHandler();
    this.getModuleList();
  },
  methods: {
    onClick(e) {
      console.log("e :>> ", e);

      this.modules = this.modules.map((m) => {
        if (m.module_category_id == e) {
          return {
            ...m,
            show: !m.show,
          };
        } else {
          return m;
        }
      });
    },
    resetHandler: function () {
      this.Roles.map((x) => {
        if (x.type === "text" || x.type === "date") {
          x.fieldvalue = "";
        } else if (x.type === "radio") {
          x.fieldvalue = true;
        }
      });
    },

    handleSubmit(flag) {
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        if (valid) {
          let loader = this.$loading.show();

          this.btenable = true;

          let body = this.getRequestBody("POST", this.Roles, this.Methods);
          MasterService.GlobalRequest(body)
            .then((response) => {
              const { data } = response;
              if (data.status) {
                if (flag) {
                  this.addPermission(data.role_id, 1);
                  this.btenable = false;
                } else {
                  this.resetHandler();
                }
              } else {
                this.btenable = false;
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError)
            .finally(() => {
              setTimeout(() => loader.hide(), 1000);
            });
        }
      });
    },

    searchFilterRoles() {
      let filterrolesArray = [];
      if (this.searchValue && this.searchValue.length > 0) {
        this.modulesCopy.forEach((m) => {
          let filteredSubModule = [];

          m.modules.forEach((subm) => {
            if (
              subm.module_name
                .toLowerCase()
                .includes(this.searchValue.toLowerCase())
            )
              filteredSubModule.push(subm);
          });

          if (filteredSubModule.length)
            filterrolesArray.push({ ...m, modules: filteredSubModule });
        });

        const uniqueModules = _.uniqBy(filterrolesArray, function (e) {
          return e.module_category_id;
        });
        this.modules = uniqueModules;
      } else {
        this.modules = this.modulesCopy;
      }
    },

    getModuleList: function () {
      let loader = this.$loading.show();
      let payload = {
        role_id: this.ro_id,
      };
      UserService.ListAllModules(payload)
        .then((response) => {
          loader.hide();
          const { data } = response;
          if (data.status) {
            loader.hide();
            this.modules = data.RecordV2;
            this.modulesCopy = data.RecordV2;
          } else {
            loader.hide();
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    addPermission(role_id, accessType) {
      let payload = {
        role_id: +role_id,
        module_id: this.selectedModules,
        del_module_id: [],
        access_id: accessType,
      };
      UserService.AddPermission(payload).then((res) => {
        console.log("res :>> ", res);
        this.$router.push({
          path: "/user-management/roles",
        });
      });
    },
    selectAllPermissions(mod) {
      const [getModule] = this.modules.filter(
        (f) => f.module_category_id == mod.module_category_id
      );

      if (mod.view) {
        this.selectedModules = getModule.modules.map((m) => m.module_id);
      } else {
        this.selectedModules = [];
      }
    },
  },
};
</script>
<style scoped>
.role-title {
  cursor: pointer;
  font-size: 18px !important;
  padding: 12px !important;
}
.th-text {
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/UserManagement/RolesComponentsOld/addRole.vue